

import { IState } from '../../../../core/IState';
import { AddRequestController } from '../controllers/addRequestController';
import '../services/addRequestService';
import '../../../../core/wizard/wizardDirective';
import '../directives/addShippingDetails/addShippingDetailsDirective';
import '../../requestDetailEdit/directives/materials/materialsDirective';
import '../../requestDetailEdit/directives/packages/packagesDirective';
import '../../requestDetailEdit/directives/assignMaterialsToPackages/assignMaterialsToPackagesDirective';
import '../../requestDetailEdit/directives/shipmentLocation/shipmentLocationDirective';
import '../directives/extraRequestDetails/extraRequestDetailsDirective';
import '../directives/confirmation/confirmationDirective';;
import '../../requestDetailEdit/directives/requestLetterEdit/requestLetterEditDirective'
import '../../../../core/directives/readOnlyText/readOnlyTextDirective';
import '../../../generateReport/services/generateReportService';
import '../../../generateReport/generateReportDirective';

export const addRequestState: IState = {
    name: 'addRequest',
    url: '/Request/addRequest',
    params: { copyRequestDetailEdit: null },
    template: require('../templates/addRequest.html'),
    controller: AddRequestController,
    controllerAs: 'vm',
    data: {
        title: 'New Request',
        navParent: 'Requests'
    }
}

angular.module('deliveryCreate.app').config(['$stateProvider', ($stateProvider: angular.ui.IStateProvider) => {
    $stateProvider.state(addRequestState);
}]);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/states/addRequestState.ts
 **/